import api from "services/api";

const authHeader = (): { access_token: string | null } => ({
  access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
});

export async function getUser(userId: string): Promise<unknown> {
  const { data } = await api.get(`industrial/customer/v1/users/${userId}`, {
    headers: authHeader(),
  });
  return data;
}

export async function getBills(params: {
  document: string | null;
  unitId: unknown;
}): Promise<unknown> {
  const { data } = await api.get(`industrial/bill/v1/bills`, {
    params: {
      document: params.document,
      "unit-id": params.unitId,
      _expand: "installments",
      _offset: 0,
      _limit: 5,
    },
    headers: authHeader(),
  });
  return data;
}

export async function getConsumption(params: {
  document: string | null;
  unitId: unknown;
  beginDate: string;
  endDate: string;
}): Promise<unknown> {
  const { data } = await api.get("industrial/bill/v1/bills/consumption", {
    params: {
      document: params.document,
      "unit-id": params.unitId,
      "begin-date": params.beginDate,
      "end-date": params.endDate,
    },
    headers: authHeader(),
  });
  return data;
}
